import { getRealMusclePoint } from "./index5.js";
import { anatomyToVector } from "./index6.js";
import { SignedAngle, TranslateAndRotate, Vectors } from "@project-rouge/rg-three";
import { Vector3 } from "three";
var mVec = new Vector3();
var realMuscleStart = new Vector3();
function addItemsToMuscle(building, muscle, addToBuilding, addToMuscle) {
	if (!addToBuilding.length) return;
	anatomyToVector(muscle, mVec);
	getRealMusclePoint(muscle, 0, realMuscleStart);
	muscle.gFUnits = addToMuscle;
	TranslateAndRotate(addToBuilding, SignedAngle(Vectors.Right, mVec), realMuscleStart);
	building.children = building.children.concat(addToBuilding);
}
export { addItemsToMuscle };

//# sourceMappingURL=index7.js.map